import EventPageTemplate from "../components/EventPageTemplate";
import { IMG } from "../data/site";
import useSEO from "../hooks/useSEO";

export default function FestePrivate() {
  useSEO(
    "Feste private: compleanni, lauree e feste in casa | Sprizziamoci",
    "Banco di mescita professionale per compleanni, lauree, anniversari e feste private in casa, ville e giardini. Cocktail e bevande alla spina, self service senza attese."
  );
  return (
    <EventPageTemplate
      eyebrow="Compleanni, lauree e feste private"
      titleLines={["Le occasioni passano.", "I brindisi restano."]}
      intro="Compleanni, lauree, anniversari o una serata tra amici: portiamo l'angolo bar dove si tiene la festa."
      image={IMG.friendsToast}
      imageAlt="Amici che brindano insieme durante una festa privata"
      occasions={[
        "Compleanni e lauree",
        "Anniversari e ricorrenze",
        "Feste in casa, in villa o in giardino",
        "Serate tra amici e cene private",
        "Ogni buona occasione che merita un brindisi",
      ]}
      paragraphs={[
        "Energia, amici e cocktail: la postazione diventa il cuore della serata.",
      ]}
      cta="Facciamo festa"
      preventivoCta
    />
  );
}
